document.addEventListener("latte:init", init);

function init () {
	var pjax = require('./lib/pjax'),
		gtm = require('./lib/gtm-events'),
		_ = require('lodash');

	var eventClassCode, eventClassName, leadSource, programCode;
	var formTypeValue = 'form';
	var poiData = '';
	var poi = null;
	var country = 'US';

	if ($(".form-default").length >= 1) {
		$(".form-default").each(function () {
			var id = $(this).attr("id") && (this.id.match(/\d+/)) ? $(this).attr("id").match(/\d+/)[0] : '';
			//onload check user poi selection
			poi = $('#form-' + id + '-field-poi').val();
			poiLogic(poi, id);
		});
	}

	// Check inputs for empty spaces. Trim as user moves through form.
	$(".form-default input").blur(function () {
		value = $(this).val().trim();
		$(this).val(value);
	});

	//onload check canada check
	if (!$('.js-form-field-canadian').prop('checked')) {
		$(".canadian-consent").addClass('hide');
	}

	/*Toggle Canadian Field*/
	$(".js-form-field-canadian").click(function () {
		var formId = (this.id.match(/\d+/)) ? this.id.match(/\d+/)[0] : ''; //null check b/c event sign up id is different from form signup
		if ($(this).prop('checked')) {
			$('.' + formId + '-canadian-consent').removeClass('hide');
		} else {
			$('.' + formId + '-canadian-consent').addClass('hide');
		}
	});

	//Remove Error on focus/click
	$('.form-default :required').keydown(function () {
		clearError(this, this.id);
	});

	$('.form-default :required').click(function () {
		clearError(this, this.id);
	});

	//clear errors for contact us form  custom dropdown that has tabindex -1

	$('.contact-form .dropdown').keydown(function () {
		$('.contact-form .dropdown input, .contact-form .dropdown label').removeClass("error");
	});

	helper.zipAutoComplete({
		selector: '.form-field-zip'
	});

	// email null validation for label
	$("#form-field-email").blur(function () {
		value = $(this).val();
		if (value === null || value === "") {

		} else {
			$("label[for=" + this.id + "]").addClass("post-focus");
		}
	});

	// Date Field
	$(".form-field-date").focus(function () {
		var field = this;
		setTimeout(function () {
			// field.type = 'date';
			$(field).addClass("highlight");
		}, 100);
	});

	$(".form-field-date").blur(function () {
		value = $(this).val();
		$(this).removeClass("highlight");
		if (value === null || value === "") {
			this.type = 'text';
		} else {
			$("label[for=" + this.id + "]").addClass("post-focus");
		}
	});

	$('.form-field-date').keydown(function () {
		clearError(this, this.id);
	});

	$('.form-field-date').click(function () {
		clearError(this, this.id);
	});

	//Medical Residency logic
	if ($('.form-default').length >= 1) {
		$('.form-medical-residency').on('change', function () {
			var formId = this.id.match(/\d+/)[0];
			var residencyValue = $(this).val();
			if (residencyValue === 'US') {
				$('#form-' + formId + '-field-country').parent().parent().hide();
				$('#form-' + formId + '-field-country').removeAttr("required");

				//US MED logic for zipcode
				$('.zipField').removeClass('hide');
				$('#form-' + formId + '-field-zip').attr("required", true);
				$('#form-' + formId + '-field-zip').removeClass('hide');

				//US MED logic for state
				$('#form-' + formId + '-field-state').parent().parent().show();
				$('#form-' + formId + '-field-state').attr("required");

				//US MED logic for school
				$('#form-' + formId + '-field-school-id').parent().parent().show();
				$('#form-' + formId + '-field-school-id').attr("required", true);
			} else { //outside USA
				$('#form-' + formId + '-field-country').parent().parent().show();
				$('#form-' + formId + '-field-country').attr("required", true);

				//US MED logic for zipcode
				$('#form-' + formId + '-field-zip').removeAttr("required");
				$('#form-' + formId + '-field-zip').addClass('hide');
				$('.zipField').addClass('hide');

				//US MED logic for state
				$('#form-' + formId + '-field-state').parent().parent().hide();
				$('#form-' + formId + '-field-state').removeAttr("required");

				//US MED logic for school
				$('#form-' + formId + '-field-school-id').parent().parent().hide();
				$('#form-' + formId + '-field-school-id').removeAttr("required");
			}
		});

		//if poi field got updated then check for state. if has state value then we update school
		$('.form-field-poi').on('change', function () {
			var formId = this.id.match(/\d+/)[0];
			poi = $(this).val();
			var state = $('#form-' + formId + '-field-state').val();
			poiLogic(poi, formId);
			if (poi && poiData && state) {
				getSchool(poi, state, formId);
			}
		});

		//if state field change then update school field.
		$('.form-field-state').on('change', function () {
			var state = $(this).val();
			var formId = this.id.match(/\d+/)[0];
			var poi = $('#form-' + formId + '-field-poi').val();
			if (poi && poiData && state) {
				getSchool(poi, state, formId);
			}
		});

		//if the school name is not in the list logic
		$('.form-field-school-id').on('change', function () {
			var formId = this.id.match(/\d+/)[0];

			if ($('#form-' + formId + '-field-school-id').val() == '1') {
				$('#form-' + formId + '-field-school-name').parent().parent().removeClass("hide");
				$('#form-' + formId + '-field-school-name').attr("required");
			} else {
				$('#form-' + formId + '-field-school-name').parent().parent().addClass('hide');
				$('#form-' + formId + '-field-school-name').removeAttr("required");
				$('#form-' + formId + '-field-school-name').val('');
			}
		});
	}

	//extra logic to handle USMLE poi
	function poiLogic (poi, formId) {
		if ($('#form-' + formId + '.form-default').attr('data-fakeDoor') !== 'true' && (poi === 'COMLEX' || poi === 'USMLE Step 1' || poi === 'USMLE Step 2 CK' || poi === 'USMLE Step 2 CS' || poi === 'USMLE Step 3' || poi === 'USMLE Step 1 and 2 CK')) {
			$('#form-' + formId + '-medical-residency').parent().parent().removeClass("hide");
			$('#form-' + formId + '-medical-residency').attr('required', true);
		} else {
			$('#form-' + formId + '-medical-residency').parent().parent().addClass("hide");
			$('#form-' + formId + '-medical-residency').removeAttr('required');
		}
	}

	//populate school if both poi and state has good value
	function getSchool (poi, state, formId) {
		$('#form-' + formId + '-field-school-id').html('<option disabled selected>School Name *</option>'); //reset back to blank dropdown
		var poiObj = _.find(poiData, function (o) {
			return _.toLower(o.name) === _.toLower(poi);
		});
		$.ajax({
			url: api.schoolList + '?programOfInterestId=' + poiObj.id + '&state=' + state,
			type: "GET",
			async: false,
			dataType: "json",
		}).done(function (data) {
			if (_.isEmpty(data.data)) {
				$('#form-' + formId + '-field-school-id').parent().parent().addClass('hide');
				$('#form-' + formId + '-field-school-id').removeAttr('required');
				$('#form-' + formId + '-field-school-id').append('<option selected value=1>My school is not in the list</option>');

				//if no school found then auto show empty school text field
				$('#form-' + formId + '-field-school-name').parent().parent().removeClass("hide");
				$('#form-' + formId + '-field-school-name').attr("required");
			} else {
				$('#form-' + formId + '-field-school-id').parent().parent().removeClass('hide');
				$('#form-' + formId + '-field-school-id').attr("required");

				$('#form-' + formId + '-field-school-id').append('<option value=1>My school is not in the list</option>');
				//if school found then auto show empty school text field
				$('#form-' + formId + '-field-school-name').parent().parent().addClass('hide');
				$('#form-' + formId + '-field-school-name').removeAttr("required");
				$('#form-' + formId + '-field-school-name').val('');
				$.each(data.data, function (k, v) {
					$('#form-' + formId + '-field-school-id').append('<option value=' + v + '>' + k + '</option>');
				});
			}
		});
	}

	// Label for un-required fields
	$('.form-default :not(:required)').blur(function () {
		value = $(this).val();
		if (value === null || value === "") {
			$("label[for='" + this.id + "']").removeClass("post-focus");
		} else {
			$("label[for='" + this.id + "']").addClass("post-focus");
		}
	});

	//single special event sign up
	if ($("#special-event-id").length == 1) {
		eventClassCode = $("#special-event-id").attr('data-event-id') ? $("#special-event-id").attr('data-event-id').trim() : '';
		eventClassName = $("#special-event-id").attr('data-class-name') ? $("#special-event-id").attr('data-class-name').trim() : '';
		leadSource = $("#special-event-id").attr('data-lead-source') ? $("#special-event-id").attr('data-lead-source').trim() : '';
		var formId = $("#special-event-id").attr('data-slice-index') ? $("#special-event-id").attr('data-slice-index').trim() : '';

		//check if we need to show under13 msg
		under13Msg(formId, $('#special-event-id').attr('data-program-code'));
	}

	//multiple special event sign up
	$(".special-event-id").click(function (e) {
		eventClassCode = $(this).attr('data-event-id') ? $(this).attr('data-event-id').trim() : '';
		eventClassName = $(this).attr('data-class-name') ? $(this).attr('data-class-name').trim() : '';
		leadSource = $(this).attr('data-lead-source') ? $(this).attr('data-lead-source').trim() : '';
		var formId = $(this).attr('data-slice-index') ? $(this).attr('data-slice-index').trim() : '';

		//If product is 52 (SHSAT product id) we show the under13 message
		$('#form-' + formId + '-top-under13').hide();

		under13Msg(formId, $(this).attr('data-program-code'));

		//If there multiple special event and allow multiple is set to true.
		if ($(this).attr('data-multiple') === 'yes') {
			$('#form-' + formId + '-thank-you').hide();
			$('#form-' + formId + '-error').hide();
			$('#form-' + formId + '.form-default').show();
		}
	});

	$(".specialEvent-submit").click(function (e) {
		formTypeValue = 'specialEvent';
	});
	$(".form-submit").click(function (e) {
		formTypeValue = 'form';
	});
	$('.js-quiz-submit').click(function (e) {
		formTypeValue = 'quiz';
	});
	//use by special event slice only

	//Show under13 message
	function under13Msg (formId, programCode) {
		var tmpArry = content.under13Program.split(",");
		if (programCode && tmpArry.indexOf(programCode.toUpperCase()) !== -1) {
			$('#form-' + formId + '-top-under13').show();
		}
	}

	//contact us radio box actions
	var contactEnrollCallback = function () {

		if ($('.higgs-checkbox').hasClass('higgs-checkbox-active')) {
			$('.higgs-checkbox').removeClass('higgs-checkbox-active');
		} else {
			$('.higgs-checkbox').addClass('higgs-checkbox-active');
		}

		var checkBox = $('.js-radio-group input[type="radio"]');
		checkBox.prop("checked", !checkBox.prop("checked"));

		if ((checkBox).is(':checked')) {
			$('.higgs-checkbox').closest('.js-radio-group').find('label').removeClass('error');
		}
	};

	$('.contact-form').on('keydown', function (e) {
		if (e.which == 13) {
			if ($('.js-radio-group input[type="radio"]').is(':focus')) {
				$(this).click();
				contactEnrollCallback();
			}
		}
	});

	$('.contact-form .higgs-checkbox').on('click', function (e) {
		e.preventDefault();
		contactEnrollCallback();
	});

	//contact us textarea actions
	$('.contact-form textarea').on('keyup', function (e) {
		var textareaValue = $('textarea').val();
		if (textareaValue === "" || textareaValue === null) {
			$('.textarea-hint').css('opacity', "1");
			//if textarea has white space remove hint
		} else {
			$('.textarea-hint').css('opacity', "0");
		}
	});

	$(".contact-form textarea").blur(function () {
		var textareaValue = $('textarea').val().trim();
		if (textareaValue !== "" && textareaValue !== null) {
			$('textarea ~ label').addClass('textarea-after-focus-filled');
		} else {
			$('textarea ~ label').removeClass('textarea-after-focus-filled');
			$('.textarea-hint').css('opacity', "1");
		}
	});

	// contact us dropdown actions
	$(document).mouseup(function (e) {
		var container = $('.contact-form .dropdown');
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('.dropdown-content').css('display', 'none');
		} else {
			if ($('.dropdown-content').is(':hidden')) {
				$('.dropdown-content').slideToggle('fast');
			}
		}
	});

	$('.contact-form .dropdown-content li').mouseover(function (e) {
		$(this).addClass('active-bg').siblings().removeClass('active-bg');
	});

	$('.contact-form .dropdown-content li').click(function (e) {
		e.preventDefault(e);
		$(this).addClass('active-color').siblings().removeClass('active-color');
		if ($(this).hasClass('active-color')) {
			$('.dropdown-content').css('display', 'none');
			var selection = $(this).parent().parent().find('input');
			selection.val($(this).html());
			$('.dropdown-inner label').addClass('dropdown-selected');
		}
	});

	$('.contact-form .dropdown').on('keydown', function (e) {
		//handle down arrow
		if (e.which == 40) {
			e.preventDefault();
			$('.dropdown-content').show();
			if ($('.dropdown-item:focus').length === 0) {
				$('.dropdown-item').first().focus().addClass('active-bg').siblings().removeClass('active-bg');
			} else {
				$('.dropdown-item:focus').next().focus().addClass('active-bg').siblings().removeClass('active-bg');
			}
		}
		//handle up arrow
		if (e.which == 38) {
			e.preventDefault();
			$('.dropdown-item:focus').prev().focus().addClass('active-bg').siblings().removeClass('active-bg');
		}
		//handle enter
		if (e.which == 13) {
			$('.dropdown-item:focus').click();
		}
		//handle tab
		if (e.which == 9) {
			$('.dropdown-content').hide();
		}
	});

	// Validate Contact Us  Form
	$(".js-contact-us-form-submit").click(function (e) {
		//reset the form
		$('#contact-us-title').show();
		$('#thank-you').hide();
		$('.form-contact-us').show();

		e.preventDefault();
		var id = $(this).attr("name"); //this should return `form-<id>`

		//validate fields
		if (checkNull(id) && validateEmail(id)) {
			//submit form

			var data = {
				"firstName": $('#' + id + '-field-firstname').val(),
				"lastName": $('#' + id + '-field-lastname').val(),
				"email": $('#' + id + '-field-email').val(),
				"phoneNumber": $('#' + id + '-field-phone').val(),
				"poi": $('#contact-us-poi').val(),
				"enrolled": $('#' + id + '-field-enrolled')[0].checked ? true : false,
				"note": $('#' + id + '-field-note').val()
			};

			// console.log(JSON.stringify(data));
			$.ajax({
				url: webToCaseApi,
				type: "POST",
				data: JSON.stringify(data),
				contentType: "application/json",
				async: false,
				success: function (d) {
					$('#thank-you').show();
					$('#contact-us-title').hide();
					$('.form-contact-us').hide();

				},
				complete: function () {
					$('html, body').animate({ scrollTop: $("#" + id + "-top").offset().top }, 300);
				},
				error: function (err) {
					// console.log('error')
				}
			});
		}
	});



	// Validate Regular Form
	$(".js-form-submit").click(function (e) {
		var id = $(this).attr("name"); //this should return `form-<id>`

		country = $('#' + id + '-country').data('country');//setup country

		var isZipCorrect = true;
		//since zip is not required, only validate if the field is not empty
		if ( !$('#' + id + '-field-zip').hasClass('hide') && $('#' + id + '-field-zip').val() !== '') {
			isZipCorrect = helper.zipValidation($('#' + id + '-field-zip').val(), $('#' + id + '-field-zip'));
		}

		if ($('#' + id + '.form-default').attr('data-fakeDoor') === 'true') {
			isZipCorrect = true;
		}

		if ($('#' + id).attr('action') === '/email') {
			isZipCorrect = true;
		}
		//validate
		if (validateTestDate(id) && checkNull(id) && validateEmail(id) && isZipCorrect) {
			var data = {};
			$.each(
				$('#' + id + '.form-default').serializeArray(),
				function (k, v) {
					if (v.value && v.name !== 'state') {
						if (v.name === 'canadaPermResident') {
							data[v.name] = v.value;
							/* jshint ignore:start */
							data['sendMarketingEmail'] = false;
							/* jshint ignore:end */
						} else if (v.name === 'sendMarketingEmail') {
							data[v.name] = v.value;
						} else {
							data[v.name] = v.value;
							/* jshint ignore:start */
							data['canadaPermResident'] = false; //If user didn't check the canadaPermResident or sendMarketingEmail field
							data['sendMarketingEmail'] = true; //If user didn't check the canadaPermResident or sendMarketingEmail field
							/* jshint ignore:end */
						}
						//USMLE data collect logic
						if ($('#' + id + '-medical-residency').val() === 'US') {
							/* jshint ignore:start */
							data['country'] = 'US';
							/* jshint ignore:end */
						}
						if ($('#' + id + '-medical-residency').val() === 'internationalMedSchool') {
							/* jshint ignore:start */
							data['country'] = 'internationalMedSchool';
							data.zip = '00000'; //default to `00000` as api to handel outside US
							delete data['schoolId'];
							/* jshint ignore:end */
						}

						//fakeDoor data collect logic we pass dummy zipCode
						if ($('#' + id + '.form-default').attr('data-fakeDoor') === 'true') {
							data.zip = '00000';
						}


						//if author dont select grad-year and it is using lead api, we pass dummy data (include fakedoor)
						//remove per WEB-6196
						// if (!$('.form-field-year').html() && $('#' + id).attr('action').indexOf('leadRegistration') !== -1) {
						// 	data.graduationYear = '1900';
						// }

						if (formTypeValue === 'specialEvent') {
							data.classCode = eventClassCode;
							data.leadSource = leadSource;
						} else if (formTypeValue === 'form') {
							//b/c we use JSON.stringify on template
							if ($('#' + id + '.form-default').attr('data-from-lead-source').trim() !== 'null') {
								data.leadSource = $('#' + id + '.form-default').attr('data-from-lead-source').trim();
							}
						} else if (formTypeValue === 'quiz') {
							if ($('#' + id + '.form-default').attr('data-quiz-lead-source').trim() !== 'null') {
								data.leadSource = $('#' + id + '.form-default').attr('data-quiz-lead-source').trim();
							}
						} else {
							delete data.classCode;
						}
					}
				});

			var action = $('#' + id).attr('action');
			if (action === '/email') {
				/* jshint ignore:start */
				var school = $('#' + id + '-field-school-id option:selected').text();//get the default selection from school list

				if (data['country'] !== 'internationalMedSchool') {
					data['schoolState'] = $('#' + id + '-field-state option:selected').text();//school state
					//if user selected school not in list, then we need to pick up on additional field.
					data['schoolName'] = (school !== 'My school is not in the list') ? school : $('#' + id + '-field-school-name').val();
				}

				data['emailList'] = emailList;
				data['PageUrl'] = window.location.href;
				data['poi'] = poi;
				data['encryption'] = $('#' + id).attr('data-form-encryption');
				/* jshint ignore:end */
			}
			submitForm(action, data, formTypeValue, id);
		}
		e.preventDefault();
	});


	function validateRadio (id) {
		var radios = ($('#' + id + ' input[type=radio]').length > 0) ? true : false;
		var radioGroup = $('#' + id + ' input[type=radio]').closest('.js-radio-group');

		if (radios) {
			validRadios = false;

			radioGroup.find('input[type="radio"]').each(function () {
				if ($(this).is(':checked')) {
					validRadios = true;
				}
			});
		}

		if (!validRadios) {
			out = false;
			$('#' + id + ' label[for="' + id + '-field-enrolled"]').addClass("error");
		}

		return out;
	}


	checkNull = function (id) {
		var $inputs = $('#' + id + '.form-default :required');
		out = true;

		$inputs.each(function () {
			value = $(this).val();

			if (value === null || value === "" || !value.trim()) {
				if ($(this).attr("type") === "radio") {
					validateRadio(id);
				}
				else {
					$(this).addClass("error");
					$("label[for=" + this.id + "]").addClass("error");
					out = false;
				}
			}
		});

		return out;
	};

	function validateEmail (id) {
		email = $('#' + id + '-field-email').val();
		if (helper.validateEmail(email)) {
			return true;
		} else {
			$('#' + id + ' .form-field-email').addClass("error");
			$('#' + id + ' label[for="' + id + '-field-email"]').addClass("error");
			return false;
		}
	}

	validateTestDate = function (id) {
		var dateField = $('#' + id + '-field-date');
		if ((dateField.length === 1) && (dateField.val() !== "")) {
			var dateString = moment($('#' + id + '-field-date').val());
			if (dateString._isValid) {
				var now = moment();
				var future = moment("2050-12-31");
				if ((dateString < now) || (dateString > future)) {
					$('#' + id + ' .form-field-date').addClass("error");
					$('#' + id + ' label[for="' + id + '-field-date"]').addClass("error");
					return false;
				} else {
					return true;
				}
			} else {
				//if invalid date show error
				$('#' + id + ' .form-field-date').addClass("error");
				$('#' + id + ' label[for="' + id + '-field-date"]').addClass("error");
				return false;
			}
		} else {
			return true;
		}
	};


	function clearError (thisInput, thisID) {
		if ($(thisInput).attr("type") === "radio") {
			$(thisInput).closest('.js-radio-group').find('label').removeClass('error');
		} else {
			$(thisInput).removeClass("error");
			$("label[for=" + thisID + "]").removeClass("error");
		}
	}

    /**
     * API call to get data Start
     */
	//Get GradYear if the field exist
	$(function () {
		if ($('.form-field-year').html()) {
			$.ajax({
				url: api.gradYear,
				type: "GET",
				async: false,
				dataType: "json",
			}).done(function (data) {
				var tempArray = $.map(data.data, function (value, index) {
					return [value];
				});
				$.each(tempArray.reverse(), function (k, v) {
					$('.form-field-year').append("<option value=" + v + ">" + v + "</option>");
				});
			});
		}
	});

	//Get state list if the field exist
	$(function () {
		if ($('.form-field-state').html()) {
			$.ajax({
				url: api.stateList,
				type: "GET",
				async: false,
				dataType: "json",
			}).done(function (data) {
				$.each(data.data, function (k, v) {
					if (k !== 'non-us-ca' && k !== 'separator') { // remove 2 extra entries
						$('.form-field-state').append("<option value=" + k + ">" + v + "</option>");
					}
				});
			});
		}
	});

	//Get POI as when the poi field exist
	$(function () {
		if ($(".form-field-poi").length >= 1) {
			$.ajax({
				url: api.poi,
				type: 'GET',
				async: false,
				dataType: 'json',
			}).done(function (data) {
				poiData = data.data;
				$.each(poiData, function (k, v) {
					$('.form-field-poi').append('<option value=' + JSON.stringify(v.name) + '>' + v.name + '</option>');
				});
			});
		}
	});

	//Get country list if the field exist
	$(function () {
		if ($('.form-field-country').html()) {
			$.ajax({
				url: api.countryList,
				type: "GET",
				async: false,
				dataType: "json",
			}).done(function (data) {
				$.each(data.countries, function (k, v) {
					$('.form-field-country').append("<option value=" + v.twoDigitCode + ">" + v.deltakCountryName + "</option>");
				});
			});
		}
	});
    /**
     * API call to get data END
     */

	var showThankYou = function (id) {
		// Hide title
		$('#' + id + '-top .title').hide();
		//$('#' + id).hide();
		$('#' + id + '-thank-you').show();
		$('html, body').animate({
			scrollTop: $("#" + id + "-top").offset().top
		}, 300);
		$('.' + id + '-intro').delay(300).fadeOut(500).slideUp(300);
		$('#' + id + '.form-default').delay(300).fadeOut(500).slideUp(300);
		$('#' + id + '-thank-you').slideDown(300).delay(800).fadeTo(500, 1);

		//Since the modal do not close after pjax reload. we going to added the remodel attribute
		var modalLinks = $('#' + id + '-thank-you').find('a');
		if (modalLinks) {
			modalLinks.each(function () {
				$(this).attr("data-remodal-action", "close");
				$(this).attr("data-close", "");
			});
		}

		var spEventId = eventClassCode;

		if (!_.isNil(spEventId) && formTypeValue === 'specialEvent') {
			var data = helper.getcourseDetails(spEventId);
			if (!_.isNil(data)) {
				var eventTitle = data.className;
				var description = data.notes ? data.notes : data.eventTypeDescription;
				var startDate = new Date(data.startDate);
				startDate = moment(startDate).format('MM/DD/YYYY');
				var endDate = new Date(data.endDate);
				endDate = moment(endDate).format('MM/DD/YYYY');
				var startTime, endTime;
				if (data.startTime && data.endTime) {
					startTime = data.startTime;
					endTime = data.endTime;
				} else if (typeof data.courseSessions !== 'undefined' && data.courseSessions.length > 0) {
					startTime = data.courseSessions[0].startTime;
					endTime = data.courseSessions[0].endTime;
				}

				$.ajax({
					url: link.addToCalendar,
					dataType: 'script',
					success: function () {
						if (!_.isNil(startTime) && !_.isNil(endTime)) {
							$('.start').html(startDate + ' ' + startTime);
							$('.end').html(endDate + ' ' + endTime);
							$('.calendar .title').html(eventTitle); // THis insert the title to calendar
							$('.addeventatc .description').html(description);
							$('.calendar').show();
						}
					}
				});
			}
		}

		if ($('#liveevent-overlay').length > 0) {
			$('.fa-close').css({
				"display": "block"
			});
			$('.liveevent-show-gate').css({
				"display": "none"
			});
		}
	};

	$('.addeventatc').click(function () {
		addeventatc.register('button-click', function (obj) {
			//Track Button Click
			gtm.analyticsEvent('AddToCalendar', 'Button click', $('#special-event-id').attr('data-event-id').trim());
		});
		addeventatc.register('button-dropdown-click', function (obj) {
			// Track event clicks
			gtm.analyticsEvent('AddToCalendar', obj.service, $('#special-event-id').attr('data-event-id').trim());
		});
	});

	//advance to next slide in quiz after form submit
	var quizSlideAdvance = function (id) {
		currentSlide = $('#' + id).closest('.quiz-slider').slick('slickCurrentSlide') + 1;
		$('#' + id).closest('.quiz-slider').slick('slickGoTo', currentSlide++);
	};

	var submitForm = function (url, data, formTypeValue, id) {
		//convert poi-name to poi-kbsProgramCode
		var poi = _.find(poiData, function (o) {
			return _.toLower(o.name) === _.toLower(data.poi);
		});
		data.programCode = poi.kbsProgramCode;

		//Edge case where getReal api accept programCode rather poi
		var getRealData;
		if (formTypeValue === 'specialEvent') {
			getRealData = JSON.parse(JSON.stringify(data));
			getRealData.programCode = data.poi;
			delete getRealData.poi;
		}

		//set the countryPR
		if (country === 'CA') {
			data.countryPR = country;
		}
		else if (['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'HR', 'IT', 'CY', 'LV', 'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'UK', 'GB'].indexOf(country) > -1)
		{
			data.countryPR = 'EU';
		}
		else {
			data.countryPR = 'US';
		}
		data.kaptestRegistration =true; //api require this to be true always
			//console.log('>>>> ' + JSON.stringify(getRealData));
			//console.log(JSON.stringify(data));
		$.ajax({
			url: url,
			type: "POST",
			data: (formTypeValue === 'specialEvent') ? JSON.stringify(helper.removeEmpty(getRealData)) : JSON.stringify(helper.removeEmpty(data)),
			contentType: "application/json",
			dataType: "json",
			async: false,
			success: function () { //Due to api issue we check status in fail
				if (formTypeValue === 'quiz') {
					quizSlideAdvance(id);
				} else {
					showThankYou(id);
				}
			}
		}).fail(function (data) {
			if (data.status === 202 || data.status === 200) {
				if (formTypeValue === 'quiz') {
					quizSlideAdvance(id);
				} else {
					showThankYou(id);
				}
			} else {
				$('html, body').animate({
					scrollTop: $("#" + id + "-top").offset().top
				}, 300);

				$('#' + id + '.form-default').hide();

				if (data.status === 406 || data.status === 0) {
					$('#' + id + '-error').show();
				} else if (data.status === 403) {
					$('#' + id + '-error').html('<h5>' + content.lessThanTen + '</h5>');
					$('#' + id + '-error').show();
				} else {
					$('#' + id + '-error').html('<h5>' + content.formError + '</h5>');
					$('#' + id + '-error').show();
				}
			}
		});
		//TODO: this is place holder code where so we can send additional info to SF since purchase api is not passing the info (like parent info)
		// if (formTypeValue === 'specialEvent') {

		// 	//Edge case: leadRegistration api need grad year. so if author didn't select, we pass dummy data.
		// 	//remove per WEB-6196
		// 	// if (data.graduationYear === undefined) {
		// 	//     data.graduationYear = 1900;
		// 	// }
		// 	$.ajax({
		// 		url: api.leadRegistrationApi,
		// 		type: "POST",
		// 		data: JSON.stringify(data),
		// 		contentType: "application/json",
		// 		dataType: "json",
		// 		async: false,
		// 		success: function (d) {
		// 			//console.log('success');
		// 		},
		// 		error: function (err) {
		// 			//console.log('error')
		// 		}
		// 	});
		// }
	};
}


//////////////////
// WEBPACK FOOTER
// ./public/js/form.js
// module id = 74
// module chunks = 0